<template>
  <div class="steps_container">
    <ul class="steps_ul progressbar">
      <li
        v-for="(step, idx) in steps"
        :key="idx"
        class="step_action"
        :data-step="idx + 1"
        :class="active>=idx?'active':''"
      >
      <!-- <div class="whiteBg"></div> -->
      <div class="bgbg" :style="active>=idx ? `background-color:${colorSchema};` : ''">
        <div class="stepNumber" :style="active>=idx ? `color: ${colorSchema};` : ''">{{idx + 1}}</div>
      </div>
        <div class="step_text text-left" v-html="step.title">
          <br />.
        </div>
        <div class="inner_step_action"></div>
        <img src="../../../src/assets/icons/stepArrow.svg" class="step-arrow" v-if="idx + 1 !== 2" alt="Arrow">
      </li>
    </ul>
  </div>
</template>

<script>
import debounce from "lodash/debounce";
export default {
  name: "step-counter",
  props: {
    grid: {
      type: Object,
      default: () => {
        `backgroundColor: "#fff";
        `;
      }
    },
    steps: {
      type: Array,
      required: true
    },
    actions: {
      type: Object
    },
    colorSchema: {
      required: false,
      type: String,
      default: '#000'
    }
  },
  data () {
    return {
      currentstep: {
        page: "bankInformation"
      }
    };
  },
  computed: {
    active () {
      const idx = this.steps.findIndex(
        step => step.page === this.$store.getters.currentPage()
      );
      return idx;
    }
  },
  methods: {
    updateComponent: debounce(function (event) {
      this.$emit("component-updated", {
        text: event.target.innerText
      });
    }, 2000),
    triggerActions () {
      if (this.actions) {
        this.actions.forEach(action => {
          this.$store.dispatch(action, { val: 123 });
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>

.steps {
  padding-top: 160px;
  padding-bottom: 110px;
}

.steps_container {
  margin-top: 50px;
  margin-bottom: 50px;
}

.steps_ul {
  padding: 0;
  margin: 0;
  text-align: center;
  margin: 0 auto;
}

.progressbar {
  counter-reset: step;
  position: relative;

  @media (max-width: 767.98px) {
    display: flex;
  }
}

.progressbar li {
  list-style: none;
  display: inline-block;
  width: 33%;
  position: relative;
  text-align: center;
  cursor: pointer;

  @media (max-width: 767.98px) {
    width: 33.3%;
  }
}
.progressbar li:first-child .step_text {
  text-align: left;
}
.progressbar li:last-child .step_text {
  text-align: right;
}
.progressbar li .step_text {
  color: #474747;
  font-size: 14px;
  letter-spacing: 0.14px;
  margin-top: 10px;
  display: inline-block;
  font-style: normal;
  font-weight: normal;
  line-height: 24px;
  text-align: center !important;
}
.progressbar li.active:after {
  border-color: #666666;
  background-color: #666666;
  color: #ffffff;
}
.progressbar li.active:before {
  background: attr(data-color);
  border-color: transparent;
  color: red;
}
.progressbar li.active .step_text {
  font-weight: 500;
}

.progressbar li:before {
  // content: attr(data-step);
  // color: #97999B;
  // font-size: 14px;
  // width: 32px;
  // height: 32px;
  // border: 2px solid #eaeaea;
  // border-radius: 100%;
  // -webkit-border-radius: 100%;
  // -moz-border-radius: 100%;
  // display: block;
  // font-weight: 800;
  // text-align: center;
  // margin: 0px auto 0px auto;
  // background-color: #eaeaea;
  // z-index: 2;
  // padding-top: 4px;
  // position: relative;
}
/*.progressbar li:after {*/
/*  content: "";*/
/*  position: absolute;*/
/*  width: 100px;*/
/*  height: 35px;*/
/*  background: url("../../../src/assets/icons/stepArrow.svg");*/
/*  background-color: transparent;*/
/*  top: 41px;*/
/*  left: 0;*/
/*  margin-right: 13px;*/
/*  border-right: unset;*/
/*  border-left: unset;*/
/*  z-index: 1;*/
/*}*/
.step_action {
  .whiteBg {
    font-size: 14px;
    width: 100px;
    height: 100px;
    border: 2px solid inherit;
    border-radius: 4px;
    display: block;
    font-weight: 800;
    text-align: center;
    margin: 0px auto 0px auto;
    background-color: white;
    z-index: 2;
    padding-top: 4px;
    position: absolute;
    left: 0;
    right: 0;
  }
  .bgbg {
  font-size: 14px;
  width: 6vw;
  height: 6vw;
  border: 2px solid inherit;
  border-radius: 4px;
  font-weight: 800;
  text-align: center;
  margin: 0px auto 0px auto;
  background-color: #C42930;
  z-index: 2;
  position: relative;
  transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
  opacity: 0.29;
  display: flex;
  align-items: center;
  justify-content: center;
  }
  .stepNumber {
    color: #FFFFFF !important;
    z-index: 2;
    transform: rotate(-45deg);
  }
}

.active .bgbg{
  opacity: 1;
}

.progressbar li:first-child:after {
  display: none;
}

.step-arrow {
  position: absolute;
  bottom: 50%;
  height: 26.6%;
  width: 20.5%;
  margin-bottom: -3%;
}

[data-step="1"]{
  .whiteBg {
    left: 15px;
    right: auto;
  }

  .bgbg {
    margin: 0 auto 0 15px;
  }

  .stepNumber {
    left: 50%;
    right: auto;
  }

  .step-arrow {
    right: 10%;
  }
}

// [data-step="2"]:after {
//   content: "";
//   position: absolute;
//   width: 100px;
//   height: 35px;
//   background: url("../../../src/assets/icons/stepArrow.svg");
//   background-color: transparent;
//   top: 41px;
//   left: -29.5%;
//   margin-right: 13px;
//   border-right: unset;
//   border-left: unset;
//   z-index: 1;
// }

// [data-step="3"]:after {
//   content: "";
//   position: absolute;
//   width: 100px;
//   height: 35px;
//   background: url("../../../src/assets/icons/stepArrow.svg");
//   background-color: transparent;
//   top: 41px;
//   left: 4.5%;
//   margin-right: 13px;
//   border-right: unset;
//   border-left: unset;
//   z-index: 1;
// }

[data-step="3"]{
  .whiteBg {
    left: auto;
    right: 15px;
  }

  .bgbg {
    margin: 0 15px 0 auto;
  }

  .stepNumber {
    left: auto;
    right: 12.5%;
  }

  .step-arrow {
    left: 10%;
  }
}

@media (max-width: 400px) {
   .steps_container {
     padding: 0 !important;
   }
   .step_text {
     font-size: 12px !important;
   }
}

@media (max-width: 992px) {
  .step_action {
    .bgbg {
      width: 8.5vw !important;
      height: 8.5vw !important;
    }
  }

  .step-arrow {
    height: 53.2%;
    width: 41%;
    margin-bottom: -6%;
  }

  [data-step="1"] {
    .step-arrow {
      right: -6%;
    }
  }

  [data-step="3"] {
    .step-arrow {
      left: -6%;
    }
  }
}
</style>